<div class="notification-dropdown">
  <div class="notification-dropdown-header">
    <h3>Notifications</h3>
    <a *ngIf="!isLoading" class="view-all-link" (click)="onViewAllClick($event)">View All</a>
  </div>
  <div class="notification-dropdown-content">
    <div *ngIf="isLoading && notificationCount === 0" class="loading-container">
      <div class="loader"></div>
      <p>Loading notifications...</p>
    </div>
    <div *ngIf="!isLoading && notificationCount === 0" class="no-notifications">
      <p>No activity</p>
    </div>
    <div *ngIf="notificationCount > 0" class="notifications-list">
      <ng-container *ngFor="let group of notificationGroups; trackBy: trackByGroup">
        <div class="notification-date-separator">{{ group.label }}</div>
        <button
          type="button"
          *ngFor="let notification of group.items; trackBy: trackByIndex"
          class="notification-item"
          [class.notification-item--unread]="isNotificationUnread(notification)"
          [class.notification-item--read]="!isNotificationUnread(notification)"
          (click)="onNotificationClick(notification); $event.stopPropagation()"
        >
          <span class="notification-event">
            {{ getEventDisplayName(notification.event, notification.data) }} -
            {{ getLicensePlateFromNotification(notification.data) }}
          </span>
          <span class="notification-time">{{ getNotificationTime(notification.timestamp) }}</span>
        </button>
      </ng-container>
    </div>
  </div>
</div>
